<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：家庭账号组有什么用？如何添加家庭账号？</p>
      <p>答：家庭账号组功能是可瀚学堂APP根据一个孩子有六个家长（父母以及两方老人）的常态，为家庭设计的方便孩子在每个家长的手机都可以使用可瀚学堂APP的功能。主账号（激活课程的那一个手机号）最多可以添加五个次账号到家庭账号组，次账号登录进入可瀚学堂APP可以获得主账号的数据，小朋友在次账号上做作业/做练习等一切操作产生的数据也会同步到主账号。</p>
      <p>添加家庭账号的具体操作如下：主账号（您激活课程的那一个手机号）进入”我的“页面，再点击【家庭账号】进入”家庭账号组“页面，点击右上角【添加按钮】，输入其他家长的名称和手机号，再填入获得的验证码，再点击右上角的【保存】，即可添加家庭账号。</p>
<div class="ha-img">
      <img src="./img/familt-account.png" alt="">
    </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted(){

  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
